import clsx from "clsx";

export type ColumnDef<T> = {
	id: keyof T;
	label?: string;
	cell?: (props: { data: T }) => React.ReactNode;
};

type DataGridProps<T> = {
	data: T;
	columns: ColumnDef<T>[];
	className?: string;
	variant?: "default" | "compact";
};

export function NestedDataGrid<T>({ data, columns }: DataGridProps<T>) {
	return (
		<table className="w-full text-base">
			<tbody>
				{columns.map((column) => (
					<tr
						key={String(column.id)}
						className="border-b last:border-b-0 border-border/50"
					>
						<td className="w-[1%] whitespace-nowrap py-3 px-4 bg-slate-50 font-semibold text-foreground-dark">
							{column.label}
						</td>
						<td className="p-3 text-foreground">{column.cell?.({ data })}</td>
					</tr>
				))}
			</tbody>
		</table>
	);
}

export default function DataGrid<T>({
	data,
	columns,
	className,
	variant = "default",
}: DataGridProps<T>) {
	return (
		<div className="flex flex-col w-full">
			<table
				className={clsx(
					"w-full",
					variant === "compact" && "text-sm",
					variant === "default" && "text-base",
					className,
				)}
			>
				<tbody>
					{columns.map((column: ColumnDef<T>) => (
						<tr
							key={String(column.id)}
							className="border-b last:border-b-0 border-border/50"
						>
							<td
								className={clsx(
									"w-[1%] whitespace-nowrap  bg-slate-50 font-semibold text-foreground-dark",
									variant === "compact" && "py-2 px-3",
									variant === "default" && "py-3 px-4",
								)}
							>
								{column.label}
							</td>
							<td
								className={clsx(
									"p-3 text-foreground",
									variant === "compact" && "py-2 px-3",
									variant === "default" && "py-3 px-4",
								)}
							>
								{column.cell?.({ data })}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
